export default "__VITE_ASSET__DUtlAHp0__"